if (!window.zuqoAutoCarouselReady) {
    window.zuqoAutoCarouselReady = true;
    const startCarousel = (track) => {
      if (track.dataset.zuqoAutoReady) return;
      const originals = Array.from(track.children);
      if (originals.length < 2 || track.scrollWidth <= track.clientWidth + 4) {
        track.dataset.zuqoRetries = String(Number(track.dataset.zuqoRetries || 0) + 1);
        if (Number(track.dataset.zuqoRetries) < 6) window.setTimeout(() => startCarousel(track), 350);
        return;
      }
      track.dataset.zuqoAutoReady = 'true';
      let pointerPaused = false;
      let focusPaused = false;
      let touchPaused = false;
      let activeVideo = null;
      let lastTime = performance.now();
      let lastPaint = 0;
      let detailsOpen = false;
      track.addEventListener('toggle', () => { detailsOpen = Boolean(track.querySelector('details[open]')); }, true);
      let animationFrame = null;
      let carouselVisible = false;
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.classList.add('zuqo-carousel-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('video').forEach((video) => {
          const poster = video.getAttribute('poster');
          const image = document.createElement('img');
          image.className = video.className;
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          if (poster) image.src = poster;
          video.replaceWith(image);
        });
        if (clone.matches('a, button')) clone.setAttribute('tabindex', '-1');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((control) => control.setAttribute('tabindex', '-1'));
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((child) => child.removeAttribute('id'));
        track.appendChild(clone);
      });
      const firstClone = track.querySelector('.zuqo-carousel-clone');
      let loopPoint = firstClone.offsetLeft - originals[0].offsetLeft;
      const shouldPause = () => {
        const videoPlaying = activeVideo && !activeVideo.paused && !activeVideo.ended;
        return pointerPaused || focusPaused || touchPaused || videoPlaying || detailsOpen;
      };
      const animate = (time) => {
        if (!carouselVisible || document.hidden) {
          animationFrame = null;
          return;
        }
        if (time - lastPaint < 32) { animationFrame = window.requestAnimationFrame(animate); return; }
        lastPaint = time;
        const delta = Math.min(time - lastTime, 50);
        lastTime = time;
        if (!shouldPause()) {
          track.scrollLeft += delta * 0.026;
          if (track.scrollLeft >= loopPoint) track.scrollLeft -= loopPoint;
        }
        animationFrame = window.requestAnimationFrame(animate);
      };
      const resumeAnimation = () => {
        if (!carouselVisible || document.hidden || animationFrame) return;
        lastTime = performance.now();
        animationFrame = window.requestAnimationFrame(animate);
      };
      track.addEventListener('pointerenter', () => { pointerPaused = true; });
      track.addEventListener('pointerleave', () => { pointerPaused = false; });
      track.addEventListener('focusin', () => { focusPaused = true; });
      track.addEventListener('focusout', () => { focusPaused = false; });
      track.addEventListener('touchstart', () => { touchPaused = true; }, { passive: true });
      track.addEventListener('touchend', () => { touchPaused = false; }, { passive: true });
      track.addEventListener('play', (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        activeVideo = event.target;
        track.querySelectorAll('video').forEach((video) => {
          if (video !== activeVideo && !video.paused) video.pause();
        });
        activeVideo.closest('.zuqo-video-card')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }, true);
      track.addEventListener('pause', (event) => {
        if (event.target === activeVideo) {
          window.setTimeout(() => {
            if (activeVideo?.paused) activeVideo = null;
          }, 0);
        }
      }, true);
      track.addEventListener('ended', (event) => {
        if (event.target === activeVideo) activeVideo = null;
      }, true);
      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.intersectionRatio < 0.35 && video === activeVideo && !video.paused) video.pause();
          });
        }, { root: track, threshold: [0, 0.35] });
        track.querySelectorAll('video').forEach((video) => videoObserver.observe(video));
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && activeVideo && !activeVideo.paused) activeVideo.pause();
        if (document.hidden && animationFrame) {
          window.cancelAnimationFrame(animationFrame);
          animationFrame = null;
        } else {
          resumeAnimation();
        }
      });
      window.addEventListener('resize', () => {
        loopPoint = firstClone.offsetLeft - originals[0].offsetLeft;
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        const carouselObserver = new IntersectionObserver((entries) => {
          carouselVisible = entries[0].isIntersecting;
          if (carouselVisible) {
            resumeAnimation();
          } else if (animationFrame) {
            window.cancelAnimationFrame(animationFrame);
            animationFrame = null;
          }
        }, { rootMargin: '0px', threshold: 0 });
        carouselObserver.observe(track);
      } else {
        carouselVisible = true;
        resumeAnimation();
      }
    };
    const initializeCarousels = (root = document) => {
      if (window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches) return;
      root.querySelectorAll('[data-zuqo-auto-carousel]').forEach((track) => {
        if (track.dataset.zuqoPending || track.dataset.zuqoAutoReady) return;
        track.dataset.zuqoPending = 'true';
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            const initialize = () => startCarousel(track);
            if ('requestIdleCallback' in window) requestIdleCallback(initialize, { timeout: 500 });
            else setTimeout(initialize, 0);
          }, { rootMargin: '0px' });
          observer.observe(track);
        } else startCarousel(track);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeCarousels());
    } else {
      initializeCarousels();
    }
    document.addEventListener('shopify:section:load', (event) => initializeCarousels(event.target));
  }
